export enum MDSRowItemSlotName {
  LeftAddon = "left-addon",
  RightAddon = "right-addon",
  LastAddon = "last-addon",
  BottomAddon = "bottom-addon",
}

export enum MDSRowItemAppearance {
  Standard = "standard",
  ActiveSuggestion = "active-suggestion",
  AudioRecordingRecording = "audio-recording-recording",
  AudioRecordingUploading = "audio-recording-uploading",
  AudioRecordingProcessing = "audio-recording-processing",
  AudioRecordingUploadingFailed = "audio-recording-uploading-failed",
  AudioRecordingProcessingFailed = "audio-recording-processing-failed",
  UpcomingCalendarEvent = "upcoming-calendar-event",
}

export interface MDSRowItemProps extends React.HTMLAttributes<HTMLDivElement> {
  noSeparator?: boolean;
  $appearance: MDSRowItemAppearance;
  $mustClickOnRowTitle: boolean;
  $isSelected: boolean | undefined;
  $isHighlighted: boolean | undefined;
  $isSpecial: boolean | undefined;
  $isDisabled?: boolean;
}
